import { Box, Flex, Skeleton, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionBox = motion(Box)

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number] },
  },
}

export interface StatCardProps {
  icon: React.ReactNode
  label: string
  value: string | number | null | undefined
  color: string
  bg: string
  isLoading?: boolean
}

export default function StatCard({ icon, label, value, color, bg, isLoading }: StatCardProps) {
  return (
    <MotionBox
      bg="white"
      borderRadius="16px"
      p={{ base: 4, md: 5 }}
      position="relative"
      overflow="hidden"
      flex={1}
      variants={cardVariants}
      whileHover={{
        scale: 1.02,
        boxShadow: '0px 8px 16px -4px #00000012',
      }}
      transition={{ duration: 0.2 }}
    >
      <Box
        position="absolute"
        top={0}
        right={0}
        w="60%"
        h="70px"
        borderRadius="0 0 0 100%"
        bg={`${color}14`}
        filter="blur(20px)"
        pointerEvents="none"
      />

      <Flex align="center" gap={3} mb={4} position="relative">
        <Flex
          w="42px"
          h="42px"
          borderRadius="12px"
          bg={bg}
          align="center"
          justify="center"
          flexShrink={0}
          color={color}
        >
          {icon}
        </Flex>
        <Text fontSize="13px" fontWeight={600} color="solid.500" lineHeight="1.2">
          {label}
        </Text>
      </Flex>

      <Box position="relative">
        {isLoading || value == null ? (
          <Skeleton h="28px" w="70px" borderRadius="8px" />
        ) : (
          <Text fontSize="24px" fontWeight={700} color="solid.900" lineHeight={1}>
            {value}
          </Text>
        )}
      </Box>
    </MotionBox>
  )
}
